import E6Resizer from "./src/resizer.vue";

E6Resizer.install = function(Vue) {
  Vue.component(E6Resizer.name, E6Resizer);
};

export default E6Resizer;
